import React from 'react';
import {Link} from 'react-router-dom';
import SiteFoot from '../../../../shared/components/footer/index';
import logo from '../../../../images/thoot.png';
import {forgetPass, resetMessage} from "./actions";
import {connect} from "react-redux";

const EMAIL_REGEXP = /\S+@\S+\.\S+/;

class ForgetPassword extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            validation: {
                email: {message: ''}
            },
            email: '',
            noEmail:false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = "Forget Password";
        this.props.resetMessage();
    }

    handleSubmit () {
        const { email } = this.state;
        if(!email){
            this.setState({noEmail:true});
        } else {
            this.setState({noEmail:false});
        }
        this.props.forgetPass({email});
    }

    onEmailChange (value) {
        if(!value){
            this.setState({
                validation: {
                    email: {
                        valid: false,
                        message: 'Email field is required.'
                    }
                },
                noEmail: true,
                email: value
            })
            return
        }

        const isValid = this.validateEmail(value);
        if(!isValid){
            this.setState({
                validation: {
                    email: {
                        valid: false,
                        message: 'Please enter a valid email.'
                    }
                },
                noEmail: false,
                email: value
            })
            return;
        }
        this.setState({
            validation: {
                email: {
                    valid: true,
                    message: ''
                }
            },
            noEmail: false,
            email: value
        })
    }

    validateEmail(email) {
        return EMAIL_REGEXP.test(String(email).toLowerCase());
    }

    render () {
        return (
            <div className="sign-in">
                <div className="sign-in__container">
                    <div className="main-block sign forgot-password">
                        <div className="main-block__logo">
                            <Link to="/">
                                <img src={logo} alt="Kerenor Booking" width="300"/>
                            </Link>
                        </div>
                        <div className="main-block__messages">
                            {!this.props.forgetPassword.emailSended && <p className="main-block__note">Enter your email address and we'll send you the instructions for resetting the password.</p>}
                            {this.props.forgetPassword.emailSended === false && !this.state.noEmail  && <small className="sign-in__validation sign-in__validation--forgot">Email address does not exist.</small>}
                            {this.state.noEmail  && <small className="sign-in__validation sign-in__validation--forgot">Email field is required!</small>}
                            {
                                this.props.forgetPassword.emailSended &&
                                <div className="alert alert-success" style={{padding: '5px'}}>
                                    <strong>Success!</strong> Please check your email to reset your password! We sent email to "{this.state.email}"
                                </div>
                            }
                        </div>
                        <div className="main-block__form">
                            <form>
                                <div className="text-field"> {/*add has-error for error styles*/}
                                    <label className="text-field__label" htmlFor="">Email Address</label>
                                    <input
                                        placeholder="yourmail@xyz.com"
                                        type="email"
                                        className="text-field__input"
                                        onChange={e => this.onEmailChange(e.target.value)}
                                    />
                                    <span className="error-message">Error Message</span>
                                </div>
                            </form>
                        </div>
                        <div className="main-block__buttons">
                            <button disabled={!this.state.validation.email.valid} className="btn btn-secondary" onClick={ this.handleSubmit }>Reset Password</button>
                            <p>
                                Don't have an account?
                                <Link to="/sign-in" className="btn btn-link">Sign In</Link>
                            </p>
                        </div>
                        <SiteFoot className="copyright"/>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        forgetPassword: state.forgetPassword,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        forgetPass: (params) => dispatch(forgetPass(params)),
        resetMessage: () => dispatch(resetMessage()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ForgetPassword/index.js